import { Divider, Stack } from '@mui/material'
import ClientNotes from 'client/components/CandidateDrawer/ClientNotes'
import DrawerComponent from 'shared/components/DrawerComponent'
import RosterCandidateRecruiterNotes from './RosterCandidateRecruiterNotes'

interface CandidateRosterNoteDrawerProps {
    isOpen: boolean
    onClose: () => void
    onSave?: () => void
    rosterCandidateId: string
    canEdit: boolean
}

export const CandidateRosterNoteDrawer = ({
    isOpen,
    onClose,
    onSave,
    rosterCandidateId,
    canEdit,
}: CandidateRosterNoteDrawerProps) => {
    const handleClose = () => {
        onClose()
    }

    return (
        <DrawerComponent
            open={isOpen}
            hasSaveButton={false}
            primaryActionText="Save"
            onCancel={handleClose}
            anchor="right"
            onClose={handleClose}
            headerTitle="Notes"
        >
            <Stack direction="column" spacing={3}>
                <RosterCandidateRecruiterNotes
                    isVisible={isOpen}
                    rosterCandidateId={rosterCandidateId}
                    onSave={onSave}
                />
                <Divider />
                <ClientNotes
                    rosterCandidateId={rosterCandidateId}
                    allowDeleteOverride={canEdit}
                    allowNewNote={false}
                />
            </Stack>
        </DrawerComponent>
    )
}
